var map = {
	"./ga_game_portrait.png": 2259,
	"./ga_header.png": 3244,
	"./ga_portada.png": 5004,
	"./ga_ss1.png": 5428,
	"./ga_ss2.png": 8991,
	"./ga_ss3.png": 902,
	"./ga_ss4.png": 1513,
	"./ga_ss5.png": 336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;